export interface TipoEventoPlanillaJSON {
    teve_id: string | null;
    teve_nombre: string;
    teve_valor: number;
    teve_tipo: string;
    teve_descripcion: any;
}

export class TipoEventoPlanilla {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private valor: number,
    private tipo: string,
    private descripcion: any
  ) {}

  static createFrom(id: string | null, nombre: string, valor: number, tipo: string, descripcion: any) {
    return new this(id, nombre, valor, tipo, descripcion);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: TipoEventoPlanilla) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TipoEventoPlanillaJSON) {
    return TipoEventoPlanilla.createFrom(
      entity.teve_id,
      entity.teve_nombre,
      entity.teve_valor,
      entity.teve_tipo,
      entity.teve_descripcion
    );
  }

  toJSON(): TipoEventoPlanillaJSON {
    return {
      teve_id: this.getId(),
      teve_nombre: this.getNombre(),
      teve_valor: this.getValor(),
      teve_tipo: this.getTipo(),
      teve_descripcion: this.getDescripcion(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getValor(): number {
    return this.valor;
  }

  getTipo(): string {
    return this.tipo;
  }

  getDescripcion(): any {
    return this.descripcion;
  }

  isGol(){
    return this.nombre === GOL;
  }
  isPenal(){
    return this.nombre === PENAL;
  }
  isDosMinutos(){
    return this.nombre === DOS_MINUTOS;
  }
  isTarjetaAmarilla(){
    return this.nombre === TARJETA_AMARILLA;
  }
  isTarjetaroja(){
    return this.nombre === TARJETA_ROJA;
  }
  isTarjetaAzul(){
    return this.nombre === TARJETA_AZUL;
  }
}

export const GOL = 'Gol';
export const PENAL = 'Penal';
export const DOS_MINUTOS = '2 minutos';
export const TARJETA_AMARILLA = 'Tarjeta amarilla';
export const TARJETA_ROJA = 'Tarjeta roja';
export const TARJETA_AZUL = 'Tarjeta azul';

